import { Typography } from '@shared/ui/typography/typography';
import { Button, Tooltip } from '@vtbhome/juicyfront';
import { AllLock } from '@vtbhome/juicyfront/indexIcon';
import React, { useEffect, useState } from 'react';
import { LockOrganizationProps } from './types';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { IconUnlock } from '@shared/icon/icon-unlock/icon-unlock';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useOrganizationLockMutation } from '../api/organization-lock-api';
import { CACHE_KEY_ORGANIZATION_LOCK } from '../config/api-constants';
import { getOrganizationStatus } from '@shared/lib/utils/get-organization-status/get-organization-status';
import { ModalLockOrganization } from './modal-lock-organization/modal-lock-organization';

export const LockOrganization: React.FC<LockOrganizationProps> = ({ organization, onSuccess }) => {
    const [, lockOrganizationResult] = useOrganizationLockMutation({ fixedCacheKey: CACHE_KEY_ORGANIZATION_LOCK });
    const [isShowModal, setIsShowModal] = useState(false);
    const isOrganizationDisabled = getOrganizationStatus(organization) === 'disabled';

    const handleClose = () => {
        setIsShowModal(false);
    };

    const handleAccept = () => {
        setIsShowModal(false);
    };

    useEffect(() => {
        if (isShowModal && lockOrganizationResult.isSuccess) {
            onSuccess();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description={`Организация успешно ${isOrganizationDisabled ? 'разблокирована' : 'заблокирована'}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            lockOrganizationResult.reset();
        } else if (isShowModal && lockOrganizationResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось ${isOrganizationDisabled ? 'разблокировать' : 'заблокировать'} организацию.\n${getQueryError(lockOrganizationResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            lockOrganizationResult.reset();
        }
    }, [isShowModal, lockOrganizationResult.isSuccess, lockOrganizationResult.isError]);

    return (
        <>
            <Tooltip position='top-end'>
                <Button
                    buttonType='secondary'
                    size='s'
                    startAdornment={isOrganizationDisabled ? <IconUnlock /> : <AllLock size='xxs' />}
                    onClick={() => setIsShowModal(true)}
                />
                <Typography size='body2_short'>
                    {isOrganizationDisabled ? 'Разблокировать' : 'Заблокировать'}
                </Typography>
            </Tooltip>
            <ModalLockOrganization
                isShow={isShowModal}
                organization={organization}
                onAccept={handleAccept}
                onClose={handleClose}
            />
        </>
    );
};
